import React from 'react';
import { Info } from 'lucide-react';

type PlatformHeaderProps = {
  platformName: string;
  description: string;
  lastUpdated?: string | null;
};

export function PlatformHeader({
  platformName,
  description,
  lastUpdated,
}: PlatformHeaderProps) {
  return (
    <div className="mb-2">
      <h1 className="text-2xl font-semibold text-foreground mb-2">{platformName}</h1>
      {description && (
        <p className="text-sm text-muted-foreground leading-relaxed max-w-2xl">{description}</p>
      )}
      {lastUpdated && (
        <div className="mt-3">
          <span className="inline-flex items-center py-1.5 px-3 text-sm text-blue-600 dark:text-blue-400 border border-blue-200 dark:border-blue-800 rounded-md bg-blue-50 dark:bg-blue-950/40">
            <Info className="w-3.5 h-3.5 flex-shrink-0 mr-1.5" />
            Content accurate as of{' '}
            <strong className="font-semibold ml-1">
              {new Date(lastUpdated).toLocaleDateString('en-US', {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
              })}
            </strong>
            .
          </span>
        </div>
      )}
    </div>
  );
};
